// extracted by mini-css-extract-plugin
module.exports = {"buttons":"DeleteTemplateModal_buttons__1d3c6","submitButton":"DeleteTemplateModal_submitButton__30DC2"};